import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { RequireAuth, RedirectIfAuth } from './components/AuthGuard';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AppShellPage from './pages/AppShellPage';
import OnboardingPage from './pages/OnboardingPage';
import AgendaPage from './pages/AgendaPage';
import ReservaPublicaPage from './pages/ReservaPublicaPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/r/:slug" element={<ReservaPublicaPage />} />
          <Route path="/login" element={<RedirectIfAuth><LoginPage /></RedirectIfAuth>} />
          <Route path="/signup" element={<RedirectIfAuth><SignupPage /></RedirectIfAuth>} />
          <Route path="/app/onboarding" element={<RequireAuth><OnboardingPage /></RequireAuth>} />
          <Route path="/app/agenda" element={<RequireAuth><AgendaPage /></RequireAuth>} />
          <Route path="/app/*" element={<RequireAuth><AppShellPage /></RequireAuth>} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
